import { useFpB2bCoupons } from '@cart-services/hooks/fp-b2b/use-fp-b2b-coupons'
import { useFpB2bProductCatalogProducts } from '@cart-services/hooks/fp-b2b/use-fp-b2b-product-catalog-products'
import { CategoryProductsFilter } from '@cart-ui/CategoryProductsFilter/CategoryProductsFilter'
import { useCategoryProductsFilter } from '@cart-ui/CategoryProductsFilter/useCategoryProductsFilter'
import { DiscountTips } from '@cart-ui/DiscountTips/DiscountTips'
import { useFastpassMerchantGoogleAnalyticEvent } from '@dni-analysis'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { Box } from '@pets-ui/Box/Box'
import { Divider } from '@pets-ui/Divider/Divider'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useProductCatalog } from '../../../../fp-b2b-shared/hooks/use-product-catalog'
import { CollapseProduct } from '../CollapseProduct/CollapseProduct'

export const CategoryProducts = ({ category }: { category: string }) => {
  const { campaignId, projectCode, countryCode, currency, campaignCode, platform } = useProductCatalog()
  const { productCatalogDto } = useFpB2bProductCatalogProducts(campaignId, projectCode, campaignCode, platform)
  const { currentCategoryProducts, isFilteredByCoupon, toggleFilterByCoupon } = useCategoryProductsFilter(category, productCatalogDto)
  const { getMergedCouponCriterions } = useFpB2bCoupons(campaignId, projectCode, countryCode, campaignCode, platform)
  const mergedCouponCriterions = getMergedCouponCriterions(currentCategoryProducts.coupon_ids || [])
  const couponIds = currentCategoryProducts?.coupon_ids || []

  const { sendProductCategoryEvent } = useFastpassMerchantGoogleAnalyticEvent({ projectCode, countryCode, campaignId })

  const handleDisplayCouponProducts = useCallbackEvent(() => {
    toggleFilterByCoupon()
    sendProductCategoryEvent('fastpass_promotion_filter')
  })
  return (
    <VStack gap={2}>
      {couponIds.length > 0 && <DiscountTips mergedCouponCriterions={mergedCouponCriterions} currency={currency} />}
      <Paper elevation={0} height="100%" position="relative" borderRadius={8}>
        <CategoryProductsFilter
          isFilteredByCoupon={isFilteredByCoupon}
          handleFilterByCouponClick={handleDisplayCouponProducts}
        />
        <Divider />
        <VStack py={2} gap={2} divider={<Divider />}>
          {currentCategoryProducts?.all_product?.map(
            parentProductGroup => (
              <CollapseProduct
                key={parentProductGroup.id}
                parentProductGroup={parentProductGroup}
                projectCode={projectCode}
                countryCode={countryCode}
              />
            ),
          )}
          <Box pl={2}>
            {currentCategoryProducts?.all_product?.length === 0 && <Text>沒有活動商品</Text>}
          </Box>
        </VStack>
      </Paper>
    </VStack>
  )
}
